export default new class faqComponent {
  constructor() {
    this.linkSelector = '_faq-link';
    this.activeLinkSelector = '_faq-link-active';
    this.contentSelector = '_faq-content';
    this.invisibleContentSelector = '_faq-content-hidden';
    this.init();
  }

  init() {
    $(document)
      .on('click', `.${this.linkSelector}`, (e) => {
        e.preventDefault();

        const { target } = e;

        if ($(target)
          .hasClass(this.activeLinkSelector)) {
          this.hideTab();
          return;
        }

        this.showTab(target);
      });
  }

  showTab(target) {
    const id = $(target)
      .attr('href');
    const tabContent = $(id);

    this.hideTab();

    $(target)
      .addClass(this.activeLinkSelector);

    tabContent.removeClass(this.invisibleContentSelector);
  }

  hideTab() {
    const tabCollection = $(`.${this.linkSelector}`);
    const tabContentCollection = $(`.${this.contentSelector}`);

    [...tabCollection].forEach(tab => $(tab)
      .removeClass(this.activeLinkSelector));
    [...tabContentCollection].forEach(el => $(el)
      .addClass(this.invisibleContentSelector));
  }
}();
